const { DateTime } = require("luxon");

export default {
    today() {
        return DateTime.local().startOf('day');
    },
    today_iso() {
        return this.today().toISODate();
    },
    to_iso(date) {
        if (DateTime.isDateTime(date))
            return date.toISODate();
        return DateTime.fromJSDate(new Date(date)).toISODate();
    },
    short_de(date) {
        if (DateTime.isDateTime(date))
            return date.setLocale("de").toLocaleString({ month: 'long', day: 'numeric', weekday: 'short' });
        return DateTime.fromJSDate(new Date(date)).setLocale("de").toLocaleString({ month: 'long', day: 'numeric', weekday: 'short' });
    },
    getStartOfWeekIso(date){
        var dateTime = DateTime.fromJSDate(date).setLocale("de");
        if (dateTime.weekday != 1)
            dateTime = dateTime.startOf("week");
        return dateTime.toISODate();
    }
}